import styled, { createGlobalStyle } from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'

export const ModalGlobalStyle = createGlobalStyle<any>`
  .react-modal {
    &-content-wrapper {
      border-radius: 4px;
      border: none;
      background: transparent;
    }

    &-ProductSelectorHeader {
      padding: 0;
    }

    &-Content {
      text-align: center;
      padding: 0;
    }

    &-Close {
      width: 25px;
      right: 10px !important;
      z-index: 2;

      > svg {
        border: none;
        background: transparent;
        width: 24px;
        height: 24px;

        path {
          stroke: transparent;
        }

        rect {
          fill: transparent;
        }

        g {
          fill: ${props => props.theme.palette.general.light};
        }
      }
    }
  }
`

export const ModalContent = styled.div`
  .section {
    &__heading,
    &__cta {
      padding: 16px;
    }

    &__heading {
      background: ${props => props.theme.palette.general.pink};

      h1 {
        ${props => props.theme.css.heading1};
        font-size: 30px;

        &::after {
          content: '';
          display: block;
          width: 40px;
          height: 1px;
          margin: 22px auto;
          background-color: ${props => props.theme.palette.general.strong};
        }
      }
    }

    &__cta {
      background: ${props => props.theme.productSelector.darkBg};
      color: ${props => props.theme.palette.general.light};
      display: flex;
      justify-content: space-between;
      ${bp('sm')`
        flex-direction: column-reverse;
      `}

      > img {
        width: 25%;
        margin-right: 15px;
        ${bp('sm')`
          margin: 20px auto;
        `}
      }
    }
  }

  h1,
  h3 {
    margin: 0;
  }

  h3 {
    ${props => props.theme.css.heading2};
  }

  button {
    background: ${props => props.theme.palette.general.strong};
    border-color: ${props => props.theme.palette.general.strong};
    margin: auto;
    padding: 16px;
  }

  p {
    strong {
      font-weight: ${props => props.theme.font.default.bold};
    }
  }
`

export const Image = styled.img`
  width: 200px;
  height: auto;
  margin: auto;
  cursor: pointer;
`
